import { FeedbackType } from '@shared/models';

const SUCCESS_MESSAGES = [
  'Thanks for the feedback.',
  'We got it!',
  'Keep your feedback coming, thanks!',
  'Appreciate it!',
  'Thanks for letting us know !',
];

export function getRandomSuccessMessage(): string {
  const index = Math.floor(Math.random() * SUCCESS_MESSAGES.length);
  return SUCCESS_MESSAGES[index];
}

export function getFeedbackMessageForHM(feedbackType: FeedbackType) {
  return feedbackType === FeedbackType.HIRING_MANAGER_GOOD_MATCH_NOTE
    ? 'Candidate has been advanced'
    : 'Candidate has been rejected';
}
